import { Box2 } from "three";
export function getShapeBounds(shape) {
    const shapePoints = shape.getPoints();
    return new Box2().setFromPoints(shapePoints);
}
//# sourceMappingURL=getShapeBounds.js.map